package nl.volleyplanner.api.files

import kotlinx.serialization.Serializable

interface FileUploadResponse {
    val succeeded: Boolean
    val handlingExceptions: List<String>
}

@Serializable
data class ErrorFileUploadResponse(
    override val handlingExceptions: List<String>
) : FileUploadResponse {
    override val succeeded: Boolean = false
}

@Serializable
data class MemberImportFileUploadResponse(
    override val succeeded: Boolean,
    override val handlingExceptions: List<String>,
    val details: MemberImportResultDetails?
) : FileUploadResponse

@Serializable
data class MemberImportResultDetails(
    val membersTotal: Int,
    val membersCreated: Int,
    val membersUpdated: Int,
    val membersDeleted: Int
)

@Serializable
data class VolunteerImportFileUploadResponse(
    override val succeeded: Boolean,
    override val handlingExceptions: List<String>,
    val details: VolunteerImportResultDetails?
) : FileUploadResponse

@Serializable
data class VolunteerImportResultDetails(
    val volunteersTotal: Int,
    val volunteersCreated: Int,
    val volunteersUpdated: Int,
    val volunteersDeleted: Int
)